import { Box, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import ClearIcon from "@mui/icons-material/Clear";
import FullArrowRightIcon from "../../Custom-imeges/CreditsScenario/FullArrowRightIcon";
import { CreditDetails } from "../../Helper";
import { useAppSelector } from "../../store/hooks";

interface AvailablePackagesProps {
  show: boolean;
  handleClose: () => void;
}
const AvailablePackagesModal = ({
  show,
  handleClose,
}: AvailablePackagesProps) => {
  const [selectedCredit, setSelectedCredit] = useState<CreditDetails | null>(
    null
  );
  const AvailablePackageCredits=useAppSelector((s)=>s.User.PackageCredits)
  return (
    <Modal
      className="DeleteModal available-packages-modal"
      show={show}
      centered
    >
      <Modal.Body className={`DeleteModalBody border-0 rounded-3 px-0`}>
        <Box className="w-100 available-packages-body">
          <Box
          className="left-part"
            sx={{
              width: "50%",
              height: "100%",
              padding: "32px 40px",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: "500",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "var(--Main_icons_color)",
              }}
            >
              Add Extra Credits
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "2rem 0rem",
              }}
            >
              {AvailablePackageCredits?.map(
                (Credit: CreditDetails, i: number) => (
                  <Box
                    className={`package-credit ${
                      selectedCredit?.creditsCount === Credit.creditsCount &&
                      "selected"
                    }`}
                    key={i}
                    onClick={() => setSelectedCredit(Credit)}
                  >
                    <img
                      alt="Credit Details"
                      src={
                        i === 0
                          ? "/Images/CreditsScenairo/FirstPackage.svg"
                          : i === 1
                          ? "/Images/CreditsScenairo/SecondPackage.svg"
                          : "/Images/CreditsScenairo/OtherPackage.svg"
                      }
                    />
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Typography className="value-of-credit">
                          {Credit.creditsCount}
                        </Typography>
                        <Typography className="credit-word">Credits</Typography>
                      </Box>
                      <Typography className="credit-dollar">
                        {Credit.cost}
                      </Typography>
                    </Box>
                  </Box>
                )
              )}
            </Box>
            <Box
              className={`btn-add-cards ${selectedCredit ? "active" : "disabled"}`}
              onClick={() =>selectedCredit&& window.open(selectedCredit?.checkoutUrl, "_self")}
            >
              Get Credits
              <span className="ms-2">
                <FullArrowRightIcon />
              </span>
            </Box>
          </Box>
          <Box
          className="right-part"
            sx={{
              width: "50%",
              height: "100%",
              backgroundImage: "var(--credit-background)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              gap: "24px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "32px 40px",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <IconButton
              aria-label="close"
              color="inherit"
              sx={{
                position: "absolute",
                top: "2%",
                right: { xs: "16px", md: "15px" },
              }}
              onClick={handleClose}
            >
              <ClearIcon />
            </IconButton>
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: "22px",
                lineHeight: "35px",
                letterSpacing: "0px",
                textAlign: "center",
                color: "var(--Main_icons_color)",
                width: "80%",
              }}
            >
              Get Credits to Enjoy Amazing AI Features
            </Typography>
            <Typography
              sx={{
                fontFamily: "Roboto",
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "25px",
                letterSpacing: "0.1px",
                textAlign: "center",
                color: "var(--Main_icons_color)",
              }}
            >
              Grab your credits today!
            </Typography>
          </Box>
        </Box>
      </Modal.Body>
    </Modal>
  );
};

export default AvailablePackagesModal;
